import getWindow from "../utils/window";

export function pushToDataLayer(args) {
  return new Promise((resolve, reject) => {
    const resolvePushToDataLayer = async () => {
      try {
        const result = await getWindow().asos.siteChrome.pushToDataLayer(args);
        resolve(result);
      } catch (e) {
        reject(e);
      }
    };
    if (getWindow().asos.siteChrome.pushToDataLayer) {
      resolvePushToDataLayer();
    } else {
      getWindow().asos.eventBus.once("pushToDataLayer-ready", () => {
        resolvePushToDataLayer();
      });
    }
  });
}
